import { makeStyles, tokens } from "@fluentui/react-components";

const useCertificationReportStyles = makeStyles({
  mockToggleRow: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  mockToggleLabel: {
    fontWeight: 500,
  },
  mockToggleInput: {
    width: "20px",
    height: "20px",
  },
  container: {
    padding: "2rem",
    maxWidth: "1200px",
    margin: "0 auto",
    background: tokens.colorNeutralBackground1,
  },
  reportHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2rem",
    paddingBottom: "1rem",
    borderBottom: `2px solid ${tokens.colorNeutralStroke1}`,
  },
  reportTitle: {},
  reportContent: {
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    minWidth: "350px",
  },
  printButtons: {
    display: "flex",
  },
  section: {
    backgroundColor: tokens.colorNeutralBackground1,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "8px",
    padding: "1.5rem",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    marginBottom: "1.5rem",
    paddingBottom: "0.5rem",
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  subsectionTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    marginBottom: "1rem",
    paddingBottom: "0.5rem",
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  subsection: {
    marginBottom: "1rem",
  },
  citationsList: {
    paddingLeft: "1rem",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
  },
  citationItem: {
    padding: "0.5rem 0",
    color: tokens.colorBrandForeground1,
    fontWeight: 600,
    cursor: "pointer",
    ":hover": {
      color: tokens.colorBrandForeground2,
    },
  },
  noCitations: {
    fontStyle: "italic",
    color: tokens.colorNeutralForeground3,
  },
  detailedCitation: {
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    background: tokens.colorNeutralBackground1,
    borderRadius: "6px",
    padding: "1.5rem",
    marginBottom: "1.5rem",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  citationTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    marginBottom: "1rem",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  citationDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  detailRow: {
    display: "flex",
    gap: "0.5rem",
  },
  detailLabel: {
    fontWeight: 600,
    color: tokens.colorNeutralForeground2,
    minWidth: "130px",
  },
  detailValue: {
    color: tokens.colorNeutralForeground1,
    overflowWrap: "break-word",
    wordBreak: "break-word",
    flex: 1,
  },
});

export default useCertificationReportStyles;
